import React, { FC, useState } from 'react';
import { Box, Button, Card, Typography, Select, MenuItem } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DateTimePicker from "react-datetime-picker";
import { useDataProvider } from 'ra-core';
import { useNotify } from 'react-admin';

import { UsersReport } from '../../types/reports';
import Loader from '../common/loader';
import "./style.css";

let competitions = ["All", "Dream home", "Lifestyle Prizes", "Fixed Odds"]

interface State {
    startDate: Date;
    endDate: Date;
    selectedCompetition: string | unknown;
}

interface Props {
    redirectToReportList: () =>  void
}

const UserReport: FC<Props> = ({redirectToReportList}) => {
    const notify = useNotify()
    const dataProvider = useDataProvider()
    const [state, setState] = useState<State>({
        startDate: new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
        endDate: new Date(),
        selectedCompetition: competitions[0]
    });
    const [loading, setLoading] = useState(false);

    const handleCompetitionChange = (event: React.ChangeEvent<{ name?: string | undefined; value: unknown; }>) => {
        if (event.target.value) {
            setState({ ...state, selectedCompetition: event.target.value })
        }
    }

    const setStartDate = (value: Date) => {
        setState({ ...state, startDate: value })
    }

    const setEndDate = (value: Date) => {
        setState({ ...state, endDate: value })
    }

    const createReport = async () => {
        const startDate = state.startDate.toISOString()
        const endDate = state.endDate.toISOString()

        if (startDate > endDate) {
            notify('The start date cannot be greater than the finish date.', 'error');
            return
        }

        try {
            setLoading(true);
            const params: UsersReport = {
                startRange: startDate,
                endRange: endDate,
                competition: state.selectedCompetition
            }
            await dataProvider.createUsersReport(params)
            notify('Users report is being generated. Users report is accessible to download in the Report list tab', 'info');
            redirectToReportList();
        } catch(err) {
            if (typeof err === "object" && err !== null) {
                const anyErr = err as any;
                if (anyErr.response?.status === 504 || anyErr.status === 504) {
                    notify('This report takes a long time to generate. It will be available in Report list after a while.', 'error', false, false, 15000);
                    return;
                }
                if (anyErr.data?.error) {
                    notify(anyErr.data.error, "error");
                    return;
                }
                if (err instanceof Error && err.message) {
                    notify(err.message, "error");
                }
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Card elevation={0} className="reportsCardWrapper" >
            <Box display="flex" alignItems="center" justifyContent="flex-start" >
                <Box style={{ width: 250 }} paddingBottom="1em">
                    <Typography gutterBottom className="base-color">
                        Start date
                    </Typography>
                </Box>
                <form >
                    <Box position="absolute">
                        <DateTimePicker
                            value={state.startDate}
                            format={"dd-MM-y h:mm:ss a"}
                            onChange={setStartDate}
                            disableClock
                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                        />
                        <Box marginTop="1em" >
                        </Box>
                    </Box>
                </form>
            </Box>

            <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="2em">
                <Box style={{ width: 250 }} paddingBottom="1em">
                    <Typography gutterBottom className="base-color">
                        Finish date
                    </Typography>
                </Box>
                <form >
                    <Box position="absolute">

                        <DateTimePicker
                            value={state.endDate}
                            format={"dd-MM-y h:mm:ss a"}
                            onChange={setEndDate}
                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                            disableClock
                        />
                        <Box marginTop="1em" >
                        </Box>
                    </Box>
                </form>
            </Box>

            <Box display="flex" alignItems="center" justifyContent="flex-start" marginTop="2em">
                <Box style={{ width: 250 }}>
                    <Typography className="base-color">
                        Competition type
                    </Typography>
                </Box>
                <Select
                    id="search-input"
                    variant="standard"
                    value={state.selectedCompetition}
                    onChange={handleCompetitionChange}
                    name="competition"
                    IconComponent={KeyboardArrowDownIcon}
                >
                    {competitions.map((name) => (
                        <MenuItem key={name} value={name} >
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            <Box style={{ width: '50%' }} marginTop='2rem' display="flex" justifyContent="space-between">
                <Button 
                    size="large" 
                    className="getReportsBtn" 
                    onClick={createReport} 
                    disabled={loading}
                    endIcon={loading ? <Loader small /> : null}
                >
                    Create
                </Button>
            </Box>
        </Card>
    )
}

export default UserReport